import { provideTransloco, TRANSLOCO_TRANSPILER, TranslocoModule } from '@jsverse/transloco';
import { isDevMode, NgModule } from '@angular/core';
import { TranslocoHttpLoader } from './transloco-loader';
import { MessageFormatTranspiler } from '@jsverse/transloco-messageformat';

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: ['es', 'en'],
        defaultLang: 'es',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader
    }),
    { provide: TRANSLOCO_TRANSPILER, useClass: MessageFormatTranspiler }
  ]
})
export class TranslocoRootModule {
}
